import { render, staticRenderFns } from "./AnswerContainer.vue?vue&type=template&id=f98bc912&scoped=true"
import script from "./AnswerContainer.vue?vue&type=script&lang=js"
export * from "./AnswerContainer.vue?vue&type=script&lang=js"
import style0 from "./AnswerContainer.vue?vue&type=style&index=0&id=f98bc912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98bc912",
  null
  
)

export default component.exports